// src/components/ErrorDisplay.tsx
import React from 'react';
import { useError } from '../../contexts/ErrorContext';

export const ErrorMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className="alert alert-danger" role="alert">
    {message}
  </div>
);

export const GlobalErrorDisplay: React.FC = () => {
  const { error, clearError } = useError();

  if (!error) return null;

  return (
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      {error.message}
      <button type="button" className="btn-close" onClick={clearError} aria-label="Close"></button>
    </div>
  );
};